<script>
import LoginLayout from '@layouts/login';
import BlockingContainer from '@components/BlockingContainer';

export default {
  page() {
    return {
      title: this.$t('titles.login'),
    };
  },
  components: {
    LoginLayout,
    BlockingContainer,
  },
  data() {
    return {
      user: {
        email: null,
        password: null,
      },
    };
  },
  methods: {
    validate() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.$wait.start('login');
          this.login();
        }
      });
    },
    login() {
      this.$store.dispatch('auth/login', {
        router: this.$router,
        redirect: 'home.index',
        user: this.user,
        callback: () => this.$wait.end('login'),
      });
    },
  },
};
</script>

<template>
  <LoginLayout>
    <b-row class="justify-content-center">
      <b-col md="6">
        <b-card
          :border-variant="!errors.items.length ? 'dark' : 'danger'"
        >
          <BlockingContainer v-if="$wait.is('login')"></BlockingContainer>
          <b-form @submit.prevent="validate">
            <b-form-group :label="`${$t('fields.email')}:`">
              <b-form-input
                id="email"
                v-model="user.email"
                v-validate="'required|email|max:255'"
                data-vv-value-path="localValue"
                data-vv-name="email"
                :data-vv-as="$t('fields.email')"
                type="text"
                :state="errors.has('email') ? false : null"
                aria-describedby="input-feedback-email"
                :placeholder="$t('placeholders.email')"
              >
              </b-form-input>

              <b-form-invalid-feedback id="input-feedback-email">
                <template v-show="errors.has('email')">{{ errors.first('email') }}</template>
              </b-form-invalid-feedback>
            </b-form-group>

            <b-form-group id="exampleInputGroup2" :label="`${$t('fields.password')}:`">
              <b-form-input
                id="password"
                v-model="user.password"
                v-validate="'required|min:6|max:255'"
                data-vv-value-path="localValue"
                data-vv-name="password"
                :data-vv-as="$t('fields.password')"
                type="password"
                :state="errors.has('password') ? false : null"
                aria-describedby="input-feedback-password"
                :placeholder="$t('placeholders.password')"
              >
              </b-form-input>

              <b-form-invalid-feedback id="input-feedback-password">
                <template v-show="errors.has('password')">{{ errors.first('password') }}</template>
              </b-form-invalid-feedback>
            </b-form-group>

            <div class="d-flex align-items-center justify-content-between">
              <b-link :to="{ name: 'forgot.index' }">{{ $t('actions.forgot_password') }}</b-link>
              <b-button class="float-right" :disabled="!!errors.items.length" type="submit" :variant="'outline-' + (!errors.items.length ? 'dark' : 'danger')">
                {{ $t('actions.submit') }}
              </b-button>
            </div>
          </b-form>
        </b-card>
      </b-col>
    </b-row>
  </LoginLayout>
</template>

<style lang="scss" module>
@import '@design';

.form {
  text-align: center;
}
</style>
